import React from 'react';
import './styles.css';

/**
 * 表單選擇組件
 * 用於顯示帶有標籤的下拉選擇框
 * 
 * @param {Object} props - 組件屬性
 * @param {string} props.id - 選擇框ID
 * @param {string} props.label - 選擇框標籤
 * @param {string} props.value - 選擇框值
 * @param {Function} props.onChange - 值變更回調函數
 * @param {Array} props.options - 選項數組，格式為 [{value: 'value1', label: '選項1'}, ...]
 * @param {boolean} props.required - 是否必填
 * @param {string} props.error - 錯誤信息
 * @param {string} props.className - 額外的CSS類名
 * @returns {JSX.Element} 表單選擇組件
 */
function FormSelect({
    id,
    label,
    value,
    onChange,
    options = [],
    required = false,
    error = '',
    className = '',
    ...rest
}) {
    return (
        <div className={`form-select-container ${error ? 'has-error' : ''} ${className}`}>
            {label && (
                <label htmlFor={id} className="form-select-label">
                    {label}
                    {required && <span className="form-select-required">*</span>}
                </label>
            )}

            <select
                id={id}
                value={value}
                onChange={onChange}
                className="form-select"
                required={required}
                {...rest}
            >
                {options.map((option) => (
                    <option key={option.value} value={option.value}>
                        {option.label}
                    </option>
                ))}
            </select>

            {error && <p className="form-select-error">{error}</p>}
        </div>
    );
}

export default FormSelect; 